import { addPhoneHiddenInpits } from "../../../../../src/js/functions";

document.addEventListener('DOMContentLoaded', () => {

   if (document.querySelector('.wcl-filter-form')) {
      const form = document.querySelector('.wcl-filter-form');
      const formWrapper = document.querySelector('.filterWrapper');

      // Get variables
      const submitBtns = form.querySelectorAll('.js-filter-form-submit');
      const inputNumber = form.querySelector("#phone_number");
      const inputEmail = form.querySelector("#user_email");
      const userAgreement = form.querySelector("#user_agreement");

      // Get UI element
      const messageBlock = form.querySelector('.wcl-message-alert');

      //Phone number mask
      let iti;

      if (inputNumber) {
         iti = window.intlTelInput(inputNumber, {
            initialCountry: 'lu',
            preferredCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
               "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
               "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
               "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
            separateDialCode: true,
            autoPlaceholder: "off",
            utilsScript: theme.themeUrl + "/build/vendor/js/intlTelInputUtils.js",
         });

         inputNumber.addEventListener('keypress', (event) => {
            // Check if the key is not a digit
            if (!/[0-9]/.test(event.key)) {
               event.preventDefault(); // Prevent input if it's not a digit
            }
         });

         addPhoneHiddenInpits(iti, inputNumber, 'code_phone_number', 'full_phone_number');
      }

      // Function to handle validation and error message display
      const validateField = (input, errorMessage) => {
         const fieldWrapper = input.closest('li');
         const errorElement = fieldWrapper.querySelector('.wcl-error-message');

         if (input.value.trim() === '') {
            // If the field is empty, show the error
            errorElement.innerHTML = errorMessage;
            errorElement.classList.add('show');
            fieldWrapper.classList.add('error');
            return false;  // Invalid
         } else if (input.type === 'email') {
            // If the field is for email, validate email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(input.value.trim())) {
               errorElement.innerHTML = multilanguage_object["Please enter a valid email address"];
               errorElement.classList.add('show');
               fieldWrapper.classList.add('error');
               return false; // Invalid
            }
         }

         // If the field is not empty and valid, clear the error
         errorElement.innerHTML = '';
         errorElement.classList.remove('show');
         fieldWrapper.classList.remove('error');
         return true;  // Valid
      };

      // Function to validate checkbox
      const validateCheckbox = (checkbox, errorMessage) => {
         const agreementBlock = checkbox.closest('.block-agreement');
         const errorElement = agreementBlock.querySelector('.wcl-error-message');

         if (!checkbox.checked) {
            // If the checkbox is not checked, show the error
            errorElement.innerHTML = errorMessage;
            errorElement.classList.add('show');
            agreementBlock.classList.add('error');
            return false;  // Invalid
         } else {
            // If the checkbox is checked, clear the error
            errorElement.innerHTML = '';
            errorElement.classList.remove('show');
            agreementBlock.classList.remove('error');
            return true;  // Valid
         }
      };

      submitBtns.forEach(button => {
         button.addEventListener('click', e => {

            e.preventDefault();

            messageBlock.classList.remove('show', 'error', 'success');

            formWrapper.classList.add('loading');

            // Check if required fields are filled
            let isValid = true;

            // Validate email
            if (inputEmail && !validateField(inputEmail, multilanguage_object["Email Required"])) {
               isValid = false;
            }

            // Validate user agreement checkbox
            if (userAgreement && !validateCheckbox(userAgreement, multilanguage_object["You must accept the privacy policy"])) {
               isValid = false;
            }

            // If form is not valid, stop submission
            if (!isValid) {
               formWrapper.classList.remove('loading');
               return;
            }

            // Get form data
            let formData = new FormData(form);

            // Serialize formData
            const params = new URLSearchParams(formData);
            const serializedData = params.toString();

            // Store serializedData into a cookie
            document.cookie = "gatewayFormData=" + serializedData + "; path=/;";

            // Set gateway_form_submitted cookie to 1
            document.cookie = "gatewayFormSubmitted=1; path=/;";

            form.submit();
         });
      });
   }
});